import {
  default_primary_color_1,
  default_primary_color_2,
  default_primary_color_3,
  default_primary_color_4,
  default_primary_color_5,
  default_secondary_color,
  default_secondary_text_color,
  default_secondary_text_color_Header_Footer,
  default_custom_login,
} from "@utilities/defaultTheme";

const themeStyleDoc = document?.documentElement?.style;

function setStyleProperty(propKey: string, propVal: any) {
  themeStyleDoc?.setProperty(propKey, propVal);
}

function hexToRGB(hex: any) {
  let r = 0;
  let g = 0;
  let b = 0;
  try {
    hex = hex.replace("#", "");
    r = parseInt(hex.slice(0, 2), 16);
    g = parseInt(hex.slice(2, 4), 16);
    b = parseInt(hex.slice(4, 6), 16);
    if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) {
      throw new Error();
    }
  } catch (e) {
    r = 0;
    g = 0;
    b = 0;
  }
  return `${r}, ${g}, ${b}`;
}

export function setDefaultTheme() {
  setDefaultPrimaryColor1Theme();
  setDefaultPrimaryColor2Theme();
  setDefaultPrimaryColor3Theme();
  setDefaultPrimaryColor4Theme();
  setDefaultPrimaryColor5Theme();
  setDefaultSecondaryColorTheme();
  setDefaultSecondaryTextColorTheme();
  setDefaultSecondaryTextColorHeaderFooterTheme();
  setDefautlCustomLogin();
}
export function setDefaultPrimaryColor1Theme() {
  try {
    setStyleProperty("--primary-color-1", default_primary_color_1);
    setStyleProperty(
      "--primary-color-1-rgb",
      hexToRGB(default_primary_color_1)
    );
  } catch (e) {
    console.log("primary color 1 is not set");
  }
}

export function setDefaultPrimaryColor2Theme() {
  try {
    setStyleProperty("--primary-color-2", default_primary_color_2);
    setStyleProperty(
      "--primary-color-2-rgb",
      hexToRGB(default_primary_color_2)
    );
  } catch (e) {
    console.log("primary color 2 is not set.");
  }
}

export function setDefaultPrimaryColor3Theme() {
  try {
    setStyleProperty("--primary-color-3", default_primary_color_3);
    setStyleProperty(
      "--primary-color-3-rgb",
      hexToRGB(default_primary_color_3)
    );
  } catch (e) {
    console.log("primary color 3 is not set");
  }
}

export function setDefaultPrimaryColor4Theme() {
  try {
    setStyleProperty("--primary-color-4", default_primary_color_4);
    setStyleProperty(
      "--primary-color-4-rgb",
      hexToRGB(default_primary_color_4)
    );
  } catch (e) {
    console.log("primary color 4 is not set");
  }
}

export function setDefaultPrimaryColor5Theme() {
  try {
    setStyleProperty("--primary-color-5", default_primary_color_5);
    setStyleProperty(
      "--primary-color-5-rgb",
      hexToRGB(default_primary_color_5)
    );
  } catch (e) {
    console.log("primary color 5 is not set");
  }
}

export function setDefaultSecondaryColorTheme() {
  try {
    setStyleProperty("--secondary-color", default_secondary_color);
    setStyleProperty(
      "--secondary-color-rgb",
      hexToRGB(default_secondary_color)
    );
  } catch (e) {
    console.log("secondary color is not set");
  }
}

export function setDefaultSecondaryTextColorTheme() {
  try {
    setStyleProperty("--secondary-text-color", default_secondary_text_color);
    setStyleProperty(
      "--secondary-text-color-rgb",
      hexToRGB(default_secondary_text_color)
    );
  } catch (e) {
    console.log("secondary text color is not set]");
  }
}

export function setDefaultSecondaryTextColorHeaderFooterTheme() {
  try {
    setStyleProperty(
      "--secondary-text-color-header-footer",
      default_secondary_text_color_Header_Footer
    );
    setStyleProperty(
      "--secondary-text-color-header-footer-rgb",
      hexToRGB(default_secondary_text_color_Header_Footer)
    );
  } catch (e) {
    console.log("secondary text color is not set]");
  }
}

export function setDefautlCustomLogin() {
  setStyleProperty("--custom-login", default_custom_login);
}

export function setPrimaryColor1Theme(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--primary-color-1", color);
      setStyleProperty("--primary-color-1-rgb", hexToRGB(color));
    } else {
      setDefaultPrimaryColor1Theme();
    }
  } catch (e) {
    console.log("primary color 1 is not set in json file.");
  }
}

export function setPrimaryColor2Theme(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--primary-color-2", color);
      setStyleProperty("--primary-color-2-rgb", hexToRGB(color));
    } else {
      setDefaultPrimaryColor2Theme();
    }
  } catch (e) {
    console.log("primary color 2 is not set in json file.");
  }
}

export function setPrimaryColor3Theme(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--primary-color-3", color);
      setStyleProperty("--primary-color-3-rgb", hexToRGB(color));
    } else {
      setDefaultPrimaryColor3Theme();
    }
  } catch (e) {
    console.log("primary color 3 is not set in json file.");
  }
}

export function setPrimaryColor4Theme(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--primary-color-4", color);
      setStyleProperty("--primary-color-4-rgb", hexToRGB(color));
    } else {
      setDefaultPrimaryColor4Theme();
    }
  } catch (e) {
    console.log("primary color 4 is not set in json file.");
  }
}

export function setPrimaryColor5Theme(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--primary-color-5", color);
      setStyleProperty("--primary-color-5-rgb", hexToRGB(color));
    } else {
      setDefaultPrimaryColor5Theme();
    }
  } catch (e) {
    console.log("primary color 5 is not set in json file.");
  }
}

export function setSecondaryColorTheme(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--secondary-color", color);
      setStyleProperty("--secondary-color-rgb", hexToRGB(color));
    } else {
      setDefaultSecondaryColorTheme();
    }
  } catch (e) {
    console.log("secondary color is not set in json file.");
  }
}

export function setSecondaryTextColorTheme(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--secondary-text-color", color);
      setStyleProperty("--secondary-text-color-rgb", hexToRGB(color));
    } else {
      setDefaultSecondaryTextColorTheme();
    }
  } catch (e) {
    console.log("secondary text color is not set in json file.");
  }
}

export function setSecondaryTextColorThemeHeaderFooter(color: string) {
  try {
    if (color != null && color != undefined) {
      setStyleProperty("--secondary-text-color-header-footer", color);
      setStyleProperty(
        "--secondary-text-color-header-footer-rgb",
        hexToRGB(color)
      );
    } else {
      setDefaultSecondaryTextColorHeaderFooterTheme();
    }
  } catch (e) {
    console.log("secondary text color is not set in json file.");
  }
}

export function setCustomLoginTheme(custom_login: string) {
  try {
    if (custom_login != null && custom_login != undefined) {
      setStyleProperty("--custom-login", custom_login);
    } else {
      setDefautlCustomLogin();
    }
  } catch (e) {
    console.log("custom login is not set in json file.");
  }
}
